export const SHIPMENT_TRACK_PAGE_V1_EVENT = "Shipment Track Page";
export const SHIPMENT_TRACK_PAGE_V1_STEPS = {
  ENTRY: "Entry",
  LOADED: "Loaded",
  NAVIGATED_TO_DETAIL_PAGE: "Navigated to Detail Page"
};
